// extracted by mini-css-extract-plugin
export default {"wave":"Body_wave__hwhYT","Question":"Body_Question__UL4hY","Bold":"Body_Bold__bY98o","OptionRow":"Body_OptionRow__Rw2KQ","Option":"Body_Option__3zQ4u"};